import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AppThunk } from '../store';
import { firestore, firestoreQuery } from '../firebase';
import { Gift, UserGift } from '../types';
import { keyBy } from 'lodash';


interface UserGiftsState {
  giftsData: {
    [ id: string ]: Gift
  };
  giftsSent: {
    [ userId: string ]: UserGift[]
  };
  loading: boolean;
}

const initialState: UserGiftsState = {
  giftsData: {},
  giftsSent: {},
  loading: false,
}



const service = createSlice({
  name: 'userGifts',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<{ isLoading: boolean, userId: string }>): UserGiftsState {
      let newState = { ...state, loading: action.payload.isLoading };

      if (!action.payload.isLoading) {
        newState = {
          ...newState,
          giftsSent: {
            ...newState.giftsSent,
            [ action.payload.userId ]: []
          },
        }
      }

      return newState;
    },
    setGifts(state, action: PayloadAction<{ userId: string, giftsSent: UserGift[] }>): UserGiftsState {
      return {
        ...state,
        giftsSent: {
          ...state.giftsSent,
          [ action.payload.userId ]: action.payload.giftsSent,
        },
        loading: false,
      }
    },
    setGiftsData(state, action: PayloadAction<{ [ id: string ]: Gift }>): UserGiftsState {
      return {
        ...state,
        giftsData: action.payload,
      }
    },

  }
});



const loadGifts = (userId: string): AppThunk => async (dispatch, getState) => {
  var state = getState().userGifts;

  if (state.giftsSent[ userId ]) {
    return;
  }

  dispatch(service.actions.setLoading({
    userId,
    isLoading: true,
  }));

  if (Object.keys(state.giftsData).length === 0) {
    const giftsData = await firestoreQuery<Gift>(firestore.collection('gifts'));
    const giftsMap = keyBy(giftsData.list, 'id');
    dispatch(service.actions.setGiftsData(giftsMap));
  }

  const queryFromMe = firestore.collection('user_gifts')
    .where('fromUserId', '==', userId)
    .orderBy('createTime', 'desc')
    .limit(250);

  const queryToMe = firestore.collection('user_gifts')
    .where('targetUserId', '==', userId)
    .orderBy('createTime', 'desc')
    .limit(250);

  const fromMe = await firestoreQuery<UserGift>(queryFromMe);
  const toMe = await firestoreQuery<UserGift>(queryToMe);

  dispatch(service.actions.setGifts({
    userId,
    giftsSent: [
      ...fromMe.list,
      ...toMe.list,
    ],
  }));
}



export const actions = {
  loadGifts,
}

export default service.reducer;